import { t } from 'i18next';

export const PROFILE_COMPLETENESS_FIELDS = [
  { name: 'logo', label: t('adminPanel.dashbord.logoLabel') },
  { name: 'canton', label: t('adminPanel.dashbord.cantonLabel') },
  { name: 'baseAddressCity', label: t('adminPanel.dashbord.baseAddressCityLabel') },
  { name: 'baseAddressStreet', label: t('adminPanel.dashbord.baseAddressStreetLabel') },
  { name: 'baseAddressZip', label: t('adminPanel.dashbord.baseAddressZipLabel') },
  { name: 'baseTel', label: t('adminPanel.dashbord.baseTelLabel') },
  { name: 'yearOfFoundation', label: t('adminPanel.dashbord.yearOfFoundationLabel') },
  { name: 'workingHours', label: t('adminPanel.dashbord.workingHoursLabel') },
  { name: 'communicationPreferences', label: t('adminPanel.dashbord.communicationPreferencesLabel') },
  { name: 'info', label: t('adminPanel.dashbord.infoLabel') },
  { name: 'baseWebsite', label: t('adminPanel.dashbord.baseWebsiteLabel') },
  { name: 'rateSecretary', label: t('adminPanel.dashbord.rateSecretaryLabel') },
  { name: 'rateAccountant', label: t('adminPanel.dashbord.rateAccountantLabel') },
  { name: 'rateAuditor', label: t('adminPanel.dashbord.rateAuditorLabel') },
  { name: 'rateExpert', label: t('adminPanel.dashbord.rateExpertLabel') },
  { name: 'employees', label: t('adminPanel.dashbord.employeesLabel') },
  { name: 'servicesSpecialisation', label: t('adminPanel.dashbord.servicesSpecialisationLabel') },
  { name: 'industries', label: t('adminPanel.dashbord.industriesLabel') },
  { name: 'languages', label: t('adminPanel.dashbord.languagesLabel') },
  { name: 'member', label: t('adminPanel.dashbord.memberLabel') },
  { name: 'software', label: t('adminPanel.dashbord.softwareLabel') },
  { name: 'pictures', label: t('adminPanel.dashbord.picturesLabel') },
  { name: 'employeeCount', label: t('adminPanel.dashbord.employeeCountLabel') },
];

export const PREMIUM_TIERS_SCORES_FIELDS = [
  {
    name: 'premiumScorePremium',
    label: t('adminPanel.dashbord.premiumScoreLabel'),
    required: true,
  },
  {
    name: 'premiumScorePremiumPlus',
    label: t('adminPanel.dashbord.premiumPlusScoreLabel'),
    required: true,
  },
];

export const MATCHING_CRITERIA_SCORES_FIELDS = [
  { name: 'matchingCriteriaCantonZipCity', label: t('adminPanel.dashbord.matchingCriteriaCantonZipCityLabel') },
  { name: 'matchingCriteriaHourlyRate', label: t('adminPanel.dashbord.matchingCriteriaHourlyRateLabel') },
  { name: 'matchingCriteriaSoftware', label: t('adminPanel.dashbord.matchingCriteriaSoftwareLabel') },
  {
    name: 'matchingCriteriaCommunicationPreferences',
    label: t('adminPanel.dashbord.matchingCriteriaCommunicationPreferencesLabel'),
  },
  { name: 'matchingCriteriaAccountingBasis', label: t('adminPanel.dashbord.matchingCriteriaAccountingBasisLabel') },
  { name: 'matchingCriteriaSpecialisation', label: t('adminPanel.dashbord.matchingCriteriaSpecialisationLabel') },
  { name: 'matchingCriteriaIndustries', label: t('adminPanel.dashbord.matchingCriteriaIndustriesLabel') },
  { name: 'matchingCriteriaSpecialOffer', label: t('adminPanel.dashbord.matchingCriteriaSpecialOfferLabel') },
];

export const ALL_FIELDS = [
  ...PROFILE_COMPLETENESS_FIELDS,
  ...PREMIUM_TIERS_SCORES_FIELDS,
  ...MATCHING_CRITERIA_SCORES_FIELDS,
];
